import {columnsDefinitions, resolveFields, citySelectList, agentSelectList, statusesList, datatableUrl, statusiVeprimitList} from "../helpers/datatables_helpers";

const ClientDatatable = () => {
    let model = 'client';
    //const model = $('#context').attr('data-model');
    //console.log('DT MODEL IS: ' + model);
    const tableFields = resolveFields(model);
    console.log("TABLE FIELDS ARE: " + tableFields)
    // begin first table
    let table = $('#kt_datatable').DataTable({
        responsive: true,
        autoWidth: false,
        // Pagination settings
        dom: `<'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        // read more: https://datatables.net/examples/basic_init/dom.html
        lengthMenu: [5, 10, 25, 50],
        pageLength: 10,
        order: [[3, 'desc']],
        language: {
            'lengthMenu': 'Display _MENU_',
        },
        searchDelay: 500,
        processing: true,
        serverSide: true,
        ajax: {
            url: datatableUrl(),
            type: 'GET',
            data: {
                // parameters for custom backend script demo
                model: model,
                columnsDef: tableFields,
            },
        },
        columns: columnsDefinitions(model),
        initComplete: function() {
            var thisTable = this;
            var rowFilter = $('<tr class="filter"></tr>').appendTo($(table.table().header()));

            this.api().columns().every(function() {
                var column = this;
                var input;

                switch (column.title()) {
                    case 'Emri':
                    case 'Telefoni':
                    case 'Numri personal':
                    case 'Dite pa kontakt':
                        input = $(`<input type="text" class="form-control form-control-sm form-filter datatable-input" data-col-index="` + column.index() + `"/>`);
                        break;
                    case 'Statusi veprimit':
                        input = statusiVeprimitList(column)
                        break;
                    case 'Qyteti':
                        input = citySelectList(column);
                        break;
                    case 'Agjenti':
                        input = agentSelectList(column);
                        break;
                    case 'Statusi':
                        input = statusesList(column);
                        break;
                    case 'Actions':
                        var search = $(`
                                <button class="btn btn-primary kt-btn btn-sm kt-btn--icon d-block col-md-12 col-lg-12">
							        <span>
							            <i class="fa fa-search"></i>
							            <span>Filtro</span>
							        </span>
							    </button>`);

                        var reset = $(`
                                <button class="btn btn-secondary kt-btn btn-sm kt-btn--icon col-md-12 col-lg-12" >
							        <span>
							           <i class="fa fa-close"></i>
							           <span>Reset</span>
							        </span>
							    </button>`);


                        $('<th>').append(search).append(reset).appendTo(rowFilter);

                        $(search).on('click', function(e) {
                            e.preventDefault();
                            var params = {};
                            $(rowFilter).find('.datatable-input').each(function() {
                                var i = $(this).data('col-index');
                                if (params[i]) {
                                    params[i] += '|' + $(this).val();
                                } else {
                                    params[i] = $(this).val();
                                }
                            });
                            $.each(params, function(i, val) {
                                // apply search params to datatable
                                table.column(i).search(val ? val : '', false, false);
                            });
                            table.table().draw();
                        });

                        $(reset).on('click', function(e) {
                            e.preventDefault();
                            $(rowFilter).find('.datatable-input').each(function(i) {
                                $(this).val('');
                                table.column($(this).data('col-index')).search('', false, false);
                            });
                            table.table().draw();
                        });
                        break;
                }

                if (column.title() !== 'Actions') {
                    $(input).appendTo($('<th>').appendTo(rowFilter));
                }
            });

            // hide search column for responsive table
            var hideSearchColumnResponsive = function() {
                thisTable.api().columns().every(function() {
                    var column = this
                    if (column.responsiveHidden()) {
                        $(rowFilter).find('th').eq(column.index()).show();
                    } else {
                        $(rowFilter).find('th').eq(column.index()).hide();
                    }
                })
            };

            // init on datatable load
            hideSearchColumnResponsive();
            // recheck on window resize
            window.onresize = hideSearchColumnResponsive;

            $('#kt_datepicker_1,#kt_datepicker_2').datepicker();
        },
        columnDefs:  [{
            targets: -1,
            width: '100px',
            title: 'Actions',
            orderable: false,

        },
            {
                targets:0,
                width: '300px',
                className: 'font-weight-bolder',
                orderable: false,
            },
            {
                targets: 1,
                width: '180px',
                orderable: false
            },
            {
                targets: 2,
                width: '150px',
                orderable: false

            },
            {
                targets: 3,
                width: '100px',
            },
            {
                targets: 4,
                width: '130px',
                orderable: false,
            },
            {
                targets: 5,
                width: '200px',
                orderable: false
            },
            {
                targets: 6,
                width: '120px',
                orderable: false
            },
            {
                targets: 7,
                width: '120px',
                orderable: false
            },
            {
                targets: 8,
                width: '150px',
                orderable: false,
            },
            {
                targets: 9
            },
            {
                targets: 10,
                width: '100px',
                orderable: false
            }

        ]
    });

    return table;
}








export default ClientDatatable;